export default "__VITE_IMAGE_ASSET__7db3f1fd__";